import { FIRECMS_LOCALE_STORAGE_KEY } from "@firecms/core";

export function getStoredFireCMSLocale(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const stored = localStorage.getItem(FIRECMS_LOCALE_STORAGE_KEY)?.trim();
  return stored || undefined;
}

export function baseLocaleCode(locale: string): string {
  return locale.split("-")[0]?.toLowerCase() ?? locale.toLowerCase();
}
